import { api } from './api'

/**
 * LOT-UPGRADE — client du module billing backend.
 *
 * Le tunnel d'abonnement vit derriere l'interrupteur `BILLING_ENABLED`
 * (env backend, defaut FALSE) : `getConfig()` est le SEUL appel qui ne
 * demande pas d'authentification — deux booleens, aucune donnee sensible —
 * et c'est lui qui decide de l'affichage du tunnel cote frontend :
 *
 *   billingEnabled=false → « Offre non activee » (etat propre du kit)
 *   billingEnabled=true, stripeConfigured=false → etat degrade
 *     « configuration incomplete », CTA desactive, jamais un crash
 *   les deux a true → tunnel complet (mode TEST Stripe tant que les cles
 *     d'exploitation ne sont pas posees en production)
 */

export interface BillingConfig {
  billingEnabled: boolean
  stripeConfigured: boolean
}

export interface Subscription {
  id: string
  userId: string
  plan: string
  status: 'active' | 'canceled' | 'past_due' | 'trialing'
  stripeCustomerId: string
  stripeSubscriptionId: string
  currentPeriodStart?: string | null
  currentPeriodEnd?: string | null
  cancelAtPeriodEnd: boolean
}

export interface CheckoutSession {
  sessionId: string
  sessionUrl: string
}

class BillingService {
  private static readonly BASE_PATH = '/billing'

  /** Config publique du tunnel : interroge l'interrupteur backend. */
  static async getConfig(): Promise<BillingConfig> {
    const response = await api.get(`${this.BASE_PATH}/config`)
    return response.data
  }

  /** Souscription de l'utilisateur courant (null si aucune). */
  static async getSubscription(): Promise<Subscription | null> {
    const response = await api.get(`${this.BASE_PATH}/subscription`)
    return response.data ?? null
  }

  /** Ouvre une session Stripe Checkout ; le navigateur suit `sessionUrl`. */
  static async createCheckoutSession(priceId?: string): Promise<CheckoutSession> {
    const response = await api.post(`${this.BASE_PATH}/create-checkout-session`, { priceId })
    return response.data
  }
}

export default BillingService
